import { UPDATE_BRAND_STATE } from "../actionTypes"

const initialState = ''

const BrandsUpdate = (state = initialState, action: any) => {
    switch (action.type) {
        case UPDATE_BRAND_STATE:
            return action.payload

        default: return state
    }
}

export default BrandsUpdate;